import React from 'react';
import { ContextTokenType, type UiModifications } from '@helpcenter/forge-ui-utils';
import { UI_MODIFICATIONS } from '@helpcenter/forge-ui-utils/src/constants';
import { ExtensionPointProvider } from '@helpcenter/forge-ui-utils/src/extension-point-provider';
import { Renderer } from '@helpcenter/forge-ui-utils/src/renderer';
import { di } from 'react-magnetic-di';
import type { ForgeAppRendererProps as ForgeAppRendererPropsBase } from '@atlassian/ui-modifications-core/root/fragment/apps-renderer/single-app-renderer/types';

export type ForgeAppRendererProps = ForgeAppRendererPropsBase & { extension: UiModifications };

export const ForgeAppRenderer = (props: ForgeAppRendererProps) => {
	di(Renderer, ExtensionPointProvider);
	const { extension, ...restProps } = props;
	return (
		<ExtensionPointProvider extensionType={UI_MODIFICATIONS}>
			<Renderer {...restProps} extension={extension} contextTokenType={ContextTokenType.JIRA} />
		</ExtensionPointProvider>
	);
};
